module.exports = __webpack_public_path__ + "static/media/191-tonga.92ef092e.svg";